

const sleep = (t) => new Promise((r) => setTimeout(r, t));

export function swiperInit() {
	var defaultSettingSwiper = {
		observer: true,
		observeParents: true,
		rewind: true,
		speed: 1205,
		loop: false,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
	};




	var primarySwiper = new Swiper(".primary-banner .swiper", {
		slidesPerView: 1,
		observer: true,
		observeParents: true,
		preventInteractionOnTransition: false,
		speed: 1205,
		autoplay: false,
		lazy: {
			loadPrevNext: true,
		},
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		loop: true,
		init: false,
		navigation: {
			nextEl: ".primary-banner .next",
			prevEl: ".primary-banner .prev",
		},

	});

	let timer = null;

	// Detect if mobile (basic check, you can refine with matchMedia)
	function isMobile() {
		return window.innerWidth <= 768;
	}

	// Function to handle video playback
	function handleVideoPlayback(slide) {
		if (timer) {
			clearTimeout(timer);
			timer = null;
		}

		// Pause all videos first
		const allVideos = document.querySelectorAll(".primary-banner-video");
		allVideos.forEach((video) => {
			video.pause();
			video.currentTime = 0;
		});

		// Pick correct video (desktop or mobile)
		const videoElement = slide.querySelector(
			isMobile()
				? ".primary-banner-video.mobile"
				: ".primary-banner-video.desktop"
		);

		if (videoElement) {
			// Play the current slide's video
			videoElement
				.play()
				.catch((error) => {
					console.log("Video playback failed:", error);
					// Fallback to next slide if video fails to play
					timer = setTimeout(() => {
						primarySwiper.slideNext();
					}, 4000);
				});

			videoElement.addEventListener(
				"ended",
				function () {
					if (primarySwiper.slides.length === 1) {
						videoElement.currentTime = 0;
						videoElement.play();
					} else {
						primarySwiper.slideNext();
					}
				},
				{ once: true }
			);
		} else {
			// If no video, set timer for next slide
			timer = setTimeout(() => {
				primarySwiper.slideNext();
			}, 4000);
		}
	}

	primarySwiper.on("slideChangeTransitionEnd", function () {
		const currentSlide = primarySwiper.slides[primarySwiper.activeIndex];
		handleVideoPlayback(currentSlide);
	});

	primarySwiper.on("init", function () {
		const currentSlide = primarySwiper.slides[primarySwiper.activeIndex];
		handleVideoPlayback(currentSlide);
	});

	// Handle video click events (play/pause toggle)
	const primaryBannerVideo = document.querySelectorAll(".primary-banner-video");
	primaryBannerVideo.forEach(function (videoElement) {
		videoElement.addEventListener("click", function () {
			if (this.paused) {
				this.play();
				this.parentNode.classList.remove("pause");
			} else {
				this.pause();
				this.parentNode.classList.add("pause");
			}
		});
	});

	primarySwiper.init();








	$(".init-swiper .swiper").each(function (index) {
		var $this = $(this);
		$this.addClass("swiper-init-" + index);
		$this
			.parents(".init-swiper")
			.find(".prev")
			.addClass("prev-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".next")
			.addClass("next-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".swiper-pagination")
			.addClass("pagination-inst-" + index);

		var swiper = new Swiper(".swiper-init-" + index, {
			...defaultSettingSwiper,
			slidesPerView: "auto",
			navigation: {
				nextEl: ".next-nav-" + index,
				prevEl: ".prev-nav-" + index,
			},
			pagination: {
				el: ".pagination-inst-" + index,
				type: "bullets",
				clickable: true,
				dynamicMainBullets: 1,
			},
		});
	});
	// Wrap Swiper initialization inside a function
	function initHistorySwiper() {
		if (window.historySwiperInitialized) return; // prevent re-init
		window.historySwiperInitialized = true;

		var historyThumb = new Swiper(".history-thumb .swiper", {
			spaceBetween: 20,
			breakpoints: {
				200: {
					spaceBetween: 0,
					slidesPerView: 3,
				},
				576: {
					slidesPerView: 4,
				},
				1024: {
					slidesPerView: 5,
				},
				1200: {
					slidesPerView: 6,
				},
				1400: {
					slidesPerView: 12, // fixed duplicate breakpoint
				},
			},
			speed: 300,
			noSwiping: true,
			lazy: {
				loadPrevNext: true,
			},
		});

		var historyMain = new Swiper(".history-main .swiper", {
			spaceBetween: 40,
			centeredSlides: true,
			speed: 1205,
			slidesPerView: 1,
			autoplay: {
				delay: 5000,
			},
			slideToClickedSlide: true,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: ".history-main .next",
				prevEl: ".history-main .prev",
			},
			thumbs: {
				swiper: historyThumb,
			},
		});
	}

	// Use IntersectionObserver to trigger when visible 10%
	const historySection = document.querySelector('.history-main');
	if (historySection) {
		const observer = new IntersectionObserver(
			(entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
						initHistorySwiper();
						observer.unobserve(entry.target); // stop observing after init
					}
				});
			},
			{
				threshold: 0.1 // 10% visible
			}
		);
		observer.observe(historySection);
	}

	var homeProductTop = new Swiper('.large-center-swiper .swiper', {
		slidesPerView: 1,
		spaceBetween: 10,
		rewind: true,
		centeredSlides: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		loop: true,
		initialSlide: 4,
		navigation: {
			nextEl: ".large-center-swiper .next",
			prevEl: ".large-center-swiper .prev",
		},
		speed: 800,
		breakpoints: {
			320: {

				slidesPerView: 1,
				spaceBetween: 10,
				allowTouchMove: true,
			},
			1024: {
				centeredSlides: true,
				allowTouchMove: true,
				slidesPerView: 3,
				spaceBetween: 0,
				allowTouchMove: true,
			},
			1201: {
				centeredSlides: true,
				allowTouchMove: true,
				slidesPerView: 5,
				spaceBetween: 0,
			},
		},

	});
	var teacherSlide = new Swiper(".teacher-achievement .swiper", {
		spaceBetween: 40,
		speed: 1205,

		breakpoints: {
			200: {
				spaceBetween: 30,
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 2,
				spaceBetween: 80,
			},
		},
		autoplay: {
			delay: 5000,
		},
		slideToClickedSlide: true,
		lazy: {
			loadPrevNext: true,
		},

		navigation: {
			nextEl: ".teacher-achievement .next",
			prevEl: ".teacher-achievement .prev",
		},

	});



	var productThumb = new Swiper(".product-thumb .swiper", {
		spaceBetween: 20,
		breakpoints: {
			200: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			476: {
				slidesPerView: 4,
			},
			768: {
				slidesPerView: 5,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 40,
			},

		},
		speed: 500,
		lazy: {
			loadPrevNext: true,
		},
	});
	var productMain = new Swiper(".product-main .swiper", {
		spaceBetween: 10,
		centeredSlides: true,
		speed: 1205,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".product-thumb  .next",
			prevEl: ".product-thumb  .prev ",
		},
		thumbs: {
			swiper: productThumb,
		},
	});
	try {
		$(".auto-center-swiper .swiper").each(function (index) {
			const $this = $(this);
			const $container = $this.parents(".auto-center-swiper");

			// Read slide-amount from parent (default: 1)
			const baseSlideAmount = parseInt($container.attr("slide-amount")) || 1;

			// Assign unique class names
			$this.addClass("swiper-init-center-" + index);
			$container.find(".prev").addClass("prev-navigation-" + index);
			$container.find(".next").addClass("next-navigation-" + index);
			$container.find(".swiper-pagination").addClass("pagination-inst-center-" + index);

			// Function to calculate responsive slidesPerView
			function getSlidesPerView() {
				const w = window.innerWidth;
				if (w < 576) return 1;
				if (w < 1024) return Math.max(1, baseSlideAmount - 1);
				return baseSlideAmount;
			}

			// Initialize Swiper
			let swiper = new Swiper(".swiper-init-center-" + index, {
				...defaultSettingSwiper,
				autoplay: {
					delay: 5000,
					pauseOnMouseEnter: false,
					disableOnInteraction: false,
				},
				slidesPerView: getSlidesPerView(),
				spaceBetween: 20,
				breakpoints: {
					200: {
						spaceBetween: 0,
					},
					1024: {
						spaceBetween: 40,
					},

				},
				navigation: {
					nextEl: ".next-navigation-" + index,
					prevEl: ".prev-navigation-" + index,
				},
				pagination: {
					el: ".pagination-inst-center-" + index,
					type: "bullets",
					clickable: true,
					dynamicMainBullets: 1,
				},
				on: {
					init: function () {
						checkSlidesAndDisable($container, $this, getSlidesPerView());
					},
				},
			});

			// Update on window resize (slidesPerView + disable check)
			window.addEventListener("resize", function () {
				const newView = getSlidesPerView();
				swiper.params.slidesPerView = newView;
				swiper.update();
				checkSlidesAndDisable($container, $this, newView);
			});
		});

		// Check if there are enough slides to enable swiper
		function checkSlidesAndDisable($container, $swiperEl, requiredSlides) {
			const totalSlides = $swiperEl.find(".swiper-slide").length;
			if (totalSlides <= requiredSlides) {
				$container.addClass("swiper-slide-disable");
			} else {
				$container.removeClass("swiper-slide-disable");
			}
		}
	} catch (error) {
		console.error(error);
	}



}